<template>
  <v-container grid-list-xl>
    <h2 class="display-1">Prüfungsstück ändern</h2>
    <v-alert :value="errorMessage" mb-4>{{ errorMessage }}</v-alert>
    <v-flex>
      <EditPruefungsstueckComponent
        :stueck="pruefungsstueck"
        :documents="documents"
        :sets="stueckSets"
        :standorte="standorte"
        :isLoading="isLoading"
        @onSave="save"
        @onUploadFile="uploadFile"
      />
    </v-flex>
  </v-container>
</template>

<script>
import sortby from 'lodash.sortby';
import EditPruefungsstueckComponent from './EditPruefungsstueckComponent';

export default {
  name: 'EditPruefungsstueckPage',
  props: ['psId'],
  data() {
    return {
      isLoading: true,
      sets: [],
      standorte: [],
      pruefungsstueck: {},
      documents: [],
      errorMessage: '',
      stueckSets: []
    };
  },
  async mounted() {
    this.isLoading = true;
    await this.loadData(this.psId);
    await this.loadDocuments(this.psId);
    this.isLoading = false;
  },
  methods: {
    async loadData(psId) {
      try {
        const [stueck, sets, standorte] = await Promise.all([
          this.$http.get(`pruefungsstueck/${psId}`),
          this.$http.get('pruefungsset'),
          this.$http.get('standort')
        ]);

        this.pruefungsstueck = stueck.body;
        this.sets = sets.body;
        this.standorte = sortby(standorte.body, ['Standort']);

        const verfahren =
          this.sets.find(f => f.ID === this.pruefungsstueck.setID).Verfahren ||
          '';
        const verfahrenSets = this.sets.filter(f => f.Verfahren === verfahren);
        this.stueckSets = sortby(verfahrenSets, ['Bezeichnung']);
      } catch (err) {
        console.error(err);
      }
    },
    async loadDocuments(psId) {
      try {
        const docs = await this.$http.get(`pruefungsstueck/${psId}/documents`);

        this.documents = docs.body.Items || [];
      } catch (err) {
        console.error(err);
      }
    },
    save(item) {
      this.$http
        .put(`pruefungsstueck/${item.ID}`, item)
        .then(resp => {
          this.$router.push({
            name: 'SingleSet',
            params: { setId: item.setID }
          });
        })
        .catch(err => {
          console.error(err);

          if (err.body.originalError) {
            this.errorMessage = err.body.originalError.info.message;
          }
        });
    },
    uploadFile(formData) {
      this.isLoading = true;
      this.$http.post(`pruefungsstueck/${this.psId}/documents`, formData).then(
        response => {
          this.loadDocuments(this.psId);
          this.isLoading = false;
        },
        err => console.log(err)
      );
    }
  },
  components: {
    EditPruefungsstueckComponent
  }
};
</script>
